export default "__VITE_ASSET__BapgwK5E__"